import { handleActions } from "redux-actions";
import {
  FETCH,
  FETCH_SUCCESS,
  FETCH_FAILURE,
  DESTROY_SUCCESS,
  ADD_PRIZES,
  SET_PRIZE_POS,
  SET_PIRATE_POS
} from "./actions";

const initialState = {
  loading: false,
  premium: false,
  authenticated: false,
  players: {
    default: {
      prizeIds: [],
      prizes: {},
      pirate: { x: 0.5, y: 0.5 }
    }
  },
  activePlayer: "default"
};

export default handleActions(
  {
    [FETCH]: state => ({
      ...state,
      loading: true
    }),
    [FETCH_SUCCESS]: (state, { payload }) => ({
      ...state,
      ...payload,
      loading: false,
      players: addInitialStateToPlayers(state.players, payload.players)
    }),
    [FETCH_FAILURE]: () => ({
      ...initialState,
      loading: false,
      authenticated: false
    }),
    [DESTROY_SUCCESS]: () => ({
      ...initialState,
      authenticated: false
    }),
    [ADD_PRIZES]: (state, { payload }) => {
      const playerName = state.activePlayer;
      const player = state.players[playerName];
      const newPrizes = payload.map(prize => ({
        zIndex: getHighestZIndex(player.prizes) + 1,
        ...prize
      }));

      return {
        ...state,
        players: {
          ...state.players,
          [playerName]: {
            ...player,
            prizeIds: [...player.prizeIds, ...prizesToIdArray(newPrizes)],
            prizes: {
              ...player.prizes,
              ...prizesToObject(newPrizes)
            }
          }
        }
      };
    },
    [SET_PRIZE_POS]: (state, { payload: { id, x, y } }) => {
      const playerName = state.activePlayer;
      const player = state.players[playerName];
      const prize = {
        ...player.prizes[id],
        pos: { x, y },
        zIndex: getHighestZIndex(player.prizes) + 1
      };

      return {
        ...state,
        players: {
          ...state.players,
          [playerName]: {
            ...player,
            prizes: {
              ...player.prizes,
              [id]: prize
            }
          }
        }
      };
    },
    [SET_PIRATE_POS]: (state, { payload }) => {
      const playerName = state.activePlayer;
      const player = state.players[playerName];

      return {
        ...state,
        players: {
          ...state.players,
          [playerName]: {
            ...player,
            pirate: {
              ...player.pirate,
              ...payload
            }
          }
        }
      };
    }
  },
  initialState
);

const addInitialStateToPlayers = (statePlayers = {}, newPlayers = {}) =>
  Object.keys(newPlayers).reduce(
    (players, player) => ({
      ...players,
      [player]: addInitialStateToPlayer(
        statePlayers[player],
        newPlayers[player]
      )
    }),
    {}
  );

const addInitialStateToPlayer = (statePlayer = {}, newPlayer = {}) => {
  const prizes = mergePlayerPrizes(statePlayer.prizes, newPlayer.prizes);

  return {
    ...newPlayer,
    prizeIds: prizesToIdArray(prizes),
    prizes: prizesToObject(prizes),
    pirate: {
      ...initialState.players.default.pirate,
      ...statePlayer.pirate,
      ...newPlayer.pirate
    }
  };
};

const mergePlayerPrizes = (statePrizes = {}, newPrizes = []) =>
  newPrizes.map(newPrize => ({
    ...statePrizes[newPrize.id],
    ...newPrize
  }));

const prizesToIdArray = prizes => prizes.map(prize => prize.id);

const prizesToObject = prizes =>
  prizes.reduce((prizes, prize) => ({ ...prizes, [prize.id]: prize }), {});

const getHighestZIndex = prizes =>
  Math.max(0, ...Object.keys(prizes).map(id => prizes[id].zIndex || 0));



// WEBPACK FOOTER //
// ./src/reducers/user/reducer.js